import React, { memo } from "react";
import { CardNotification } from "@foris/avocado-suite";
import css from "./bottomInfo.module.scss";
import { Link } from "react-router-dom";

interface Props {
  contextUrl: string;
}

const BottomInfo: React.FC<Props> = ({ contextUrl }) => {
  return (
    <CardNotification
      className={css.infoContainer}
      state="info"
      title={"Estamos validando los datos."}
    >
      <p className={css.info}>
        <span>El proceso puede demorar varios minutos.</span>
        <span>
          Actualiza la página o revisa el{" "}
          <Link to={`/editor/groups-manager/change_history/${contextUrl}`}>
            historial de cambios
          </Link>
          , para ver los cambios.
        </span>
      </p>
    </CardNotification>
  );
};

export default memo(BottomInfo);
